import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Building Table (/building)
 */
export const buildingTableTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_BuildingTable_Welcome_Title"),
    description: t("Tour_BuildingTable_Welcome_Description"),
    target: () => queryTourTarget("building-table-section"),
    placement: "bottom",
  },
  {
    title: t("Tour_BuildingTable_Add_Title"),
    description: t("Tour_BuildingTable_Add_Description"),
    target: () => queryTourTarget("building-add-button"),
    placement: "left",
  },
];
